module.exports = __webpack_public_path__ + "img/icon_2_37.2a1f6a4f.png";